import SecureMacPolicyLayout, { SecureMacPolicySection } from "@/components/SecureMacPolicyLayout";

export default function SecureMacRefunds() {
  return (
    <SecureMacPolicyLayout
      eyebrow="SecureShield refunds"
      title="Refunds that respect Australian Consumer Law."
      description="This page explains how SecureShield Pro direct refunds are handled. A voluntary numeric refund window is published only after company approval."
      seoTitle="SecureShield Refunds — LightningFlow"
      canonicalPath="/secureshield/refunds"
    >
      <SecureMacPolicySection title="Australian Consumer Law">
        <p>
          Nothing in this policy excludes, restricts or modifies a right, remedy, guarantee or other
          protection that cannot lawfully be excluded under the Australian Consumer Law. If SecureShield
          Pro fails to meet a consumer guarantee, you may be entitled to a repair, replacement or
          refund as the law requires.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="App Store purchases">
        <p>
          Mac App Store purchases of SecureShield are refunded under Apple&apos;s App Store process and
          policies. Contact Apple for those purchases.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="SecureShield Pro direct purchases">
        <p>
          Direct SecureShield Pro purchases are processed by Stripe for LightningFlow (TripleThree Global
          Pty Ltd, South Australia). To request a refund, email{" "}
          <a className="underline" href="mailto:contact@lightningflow.ai?subject=SecureShield%20Pro%20refund">
            contact@lightningflow.ai
          </a>{" "}
          with your account email and purchase reference from the Stripe receipt.
        </p>
        <p>
          A company-approved voluntary refund window will be stated here only after it is approved.
          Until then, requests are assessed under Australian Consumer Law and the published Pro terms.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="After a refund">
        <p>
          A full refund, chargeback or dispute may revoke SecureShield Pro download access and license
          refresh for the affected purchase. Partial outcomes follow the approved commercial policy
          for that case.
        </p>
      </SecureMacPolicySection>
    </SecureMacPolicyLayout>
  );
}
